import { useCallback } from 'react';
import { useConfig } from '../../../../context';
export const useShouldShowRefundSuccessModal = () => {
    var _a;
    const successModal = (_a = useConfig().Engine.refund) === null || _a === void 0 ? void 0 : _a.successModal;
    return useCallback((step, status) => { var _a, _b; return (_b = (_a = successModal === null || successModal === void 0 ? void 0 : successModal[step]) === null || _a === void 0 ? void 0 : _a[status]) !== null && _b !== void 0 ? _b : true; }, [successModal]);
};
